import { createSlice } from '@reduxjs/toolkit';
import { PERMALINKS_INITIAL_STATE } from './permalinks.constants';
import {
  createPermalinkReducer,
  getPermalinksReducer,
  updatePermalinkReducer,
} from './permalinks.reducers';

const permalinksSlice = createSlice({
  name: 'permalinks',
  initialState: PERMALINKS_INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    getPermalinksReducer(builder);
    createPermalinkReducer(builder);
    updatePermalinkReducer(builder);
  },
});

export default permalinksSlice.reducer;
